

















































import { snakeCase } from 'lodash'
import moment from 'moment'
import { Component, Mixins, Prop } from 'vue-property-decorator'

import ClipboardCopyMixin from '../../../../../logic/helpers/ClipboardCopyMixin'
import { tgLoginLink, atSignedLogin } from '../../../../../shared/utils/tgLoginHelpers';
import AListCustomItem from '../../../../AListCustom/AListCustomItem.vue'
import { UserProfile } from '../../../../BotUsers/components/Users/types'
import UserMainInfo from '../../../../UserMainInfo.vue'

@Component({
  components: {
    UserMainInfo,
    AListCustomItem,
  },
  data() {
    return {
      moment,
      snakeCase,
      atSignedLogin
    }
  }
})
export default class StaticInfo extends Mixins<ClipboardCopyMixin>(ClipboardCopyMixin) {
  @Prop() profile!: UserProfile

  get createdDate() {
    return this.datesObject(this.profile.created)
  }

  get lastActionTime() {
    return this.datesObject(this.profile.lastActionTime)
  }

  get link() {
    if (this.profile.referrer?.login) {
      return tgLoginLink(this.profile.referrer.login)
    }

    return null
  }

  datesObject(date: string | undefined) {
    return {
      date: this.profile && date ? moment(date).format('LLL') : '-',
      passedDays: this.profile && date ? moment().diff(moment(date), 'days') : '-'
    }
  }
}
